/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { withStore } from 'fierry/react';

import Level from 'solis/navigation/level';

import * as Util from 'solis/navigation/util';


const getInitialState = () =>
{
  return { ...(window.history.state || { history: Util.getInitialHistory() }), pending: false };
};


const reconcile = (state, { history }) =>
{
  return { history, pending: false };
};


const replaceArgs = (state, args, { publicArgs }) =>
{
  const current = Util.getEntry(state);

  return replaceStateArgs(state, Util.resolveReplaceArgs(state, args, current.level), publicArgs);
};


const clearArgs = (state, args, { publicArgs }) =>
{
  const current = Util.getEntry(state);

  return replaceStateArgs(state, Util.getInheritedArgs(state, current.level), publicArgs);
};


const replaceStateArgs = (state, args, publicArgs) =>
{
  if (state.pending)
  {
    return state;
  }

  const current = Util.getEntry(state);

  const entry = { ...current, args };

  return replaceHistoryState({ history: [ ...Util.popEntries(state), entry ] }, publicArgs);
};


const replaceHistoryState = (state, publicArgs) =>
{
  window.history.replaceState(state, '', Util.getStateURL(state, publicArgs));

  return { ...state, pending: false };
};


const pushForeground = (state, action, props) =>
{
  return pushState(state, { ...action, level: Level.Foreground }, props);
};


const pushBackground = (state, action, props) =>
{
  return pushState(state, { ...action, level: Level.Background }, props);
};


const pushState = (state, action, { publicArgs }) =>
{
  if (state.pending)
  {
    return state;
  }

  const entry = Util.resolvePushState(state, action);

  if (Util.isSameEntry(Util.getEntry(state), entry))
  {
    return state;
  }

  return pushHistoryState({ history: [ ...state.history, entry ] }, publicArgs);
};


const pushHistoryState = (state, publicArgs) =>
{
  window.history.pushState(state, '', Util.getStateURL(state, publicArgs));

  return { ...state, pending: false };
};


const popBeforeLevel = (state, action, props) =>
{
  return popHistoryState(state, Util.getPopCountBefore(state, action.level), props);
};


const popToLevel = (state, action, props) =>
{
  return popHistoryState(state, Util.getPopCountTo(state, action.level), props);
};


const popHistoryState = (state, popCount, props) =>
{
  if (state.pending)
  {
    return state;
  }

  if (popCount === 0)
  {
    return clearArgs(state, null, props);
  }

  if (popCount < 0 || popCount >= state.history.length)
  {
    return state;
  }

  window.history.go(-popCount);

  return { ...state, pending: true };
};


export default withStore(getInitialState, { reconcile, replaceArgs, clearArgs, pushForeground, pushBackground, pushState, popBeforeLevel, popToLevel });
